
import * as fromActions from '../actions';
import { TransaccionesState } from '../models/store.models';

const initialState: TransaccionesState = {
    transacciones: null,
    transaccionData: null,
    hasTransactions: null
}

export function transaccionesStateReducer(state: TransaccionesState = initialState, action: fromActions.TransactionActions): TransaccionesState {
    switch (action.type) {
        case fromActions.SET_TRANSACTIONS:
            return {
                ...state,
                transacciones : action.transaccionesSeteadas
            }
        case fromActions.SET_TRANSACTIONS_DATA:
            return {
                ...state,
                transaccionData : action.transaccionData
            }
        case fromActions.SET_HAS_TRANSACTIONS:
            return {
                ...state,
                hasTransactions : action.hasTransactions
            }
        case fromActions.UNSET_TRANSACTIONS_DATA:
            return {
                ...state,
                transaccionData : null
            }
        case fromActions.UNSET_TRANSACTIONS:
            return {
                ...state,
                transacciones : null
            }
        case fromActions.UNSET_HAS_TRANSACTIONS:
            return {
                ...state,
                hasTransactions : null
            }
        default:
            return state
    }
}
